function createWebsiteLeadCaptureTracking(root) {
    const sent = new Set();

    function allowed(category) {
        try {
            return !root.PonoCookieConsent || root.PonoCookieConsent.allowed(category);
        } catch (error) {
            return false;
        }
    }

    function sendOnce(key, send) {
        if (sent.has(key)) return;
        try {
            sent.add(key);
            send();
        } catch (error) {
            sent.delete(key);
        }
    }

    return {
        trackSuccess(response) {
            const event = response && response.success === true && response.conversion;
            if (!event || event.type !== 'resource_request' || !event.event_id || !event.offer) return;

            if (event.analytics_allowed === true && allowed('analytics') && typeof root.gtag === 'function') {
                sendOnce('ga4:' + event.event_id, () => root.gtag('event', 'generate_lead', {
                    event_id: event.event_id,
                    lead_type: 'resource_request',
                    offer: event.offer,
                    capture_id: event.capture_id,
                }));
            }

            if (event.marketing_allowed === true && allowed('marketing') && typeof root.fbq === 'function') {
                sendOnce('meta:' + event.event_id, () => root.fbq('track', 'Lead', {
                    content_name: event.offer,
                    content_category: 'resource_request',
                }, {eventID: event.event_id}));
            }
        },
    };
}

if (typeof window !== 'undefined') {
    window.PonoWebsiteLeadCapture = createWebsiteLeadCaptureTracking(window);
}

module.exports = {createWebsiteLeadCaptureTracking};
